<div class="auth-backdrop" [attr.data-theme]="'pxlvd'">
  <div class="auth-card" (keydown)="onKeydown($event)">

    <!-- Logo -->
    <div class="auth-logo">
      <span class="logo-pxl">pxl</span><span class="logo-vd">vd</span><span class="logo-com">.com</span>
    </div>
    <p class="auth-tagline">Pixel video studio</p>

    <!-- Tabs -->
    <div class="auth-tabs" *ngIf="view() !== 'forgot'">
      <button class="auth-tab" [class.active]="view() === 'login'" (click)="setView('login')">Sign In</button>
      <button class="auth-tab" [class.active]="view() === 'signup'" (click)="setView('signup')">Create Account</button>
    </div>

    <!-- Success message -->
    <div class="auth-success" *ngIf="successMsg">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
      {{ successMsg }}
    </div>

    <!-- Error message -->
    <div class="auth-error" *ngIf="errorMsg">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
      {{ errorMsg }}
    </div>

    <!-- ── Login view ── -->
    <ng-container *ngIf="view() === 'login'">
      <div class="auth-field">
        <label class="auth-label">Email</label>
        <input class="auth-input" type="email" [(ngModel)]="email"
          placeholder="you@example.com" autocomplete="email" autofocus>
      </div>
      <div class="auth-field">
        <label class="auth-label">
          Password
          <button class="auth-link-btn" (click)="setView('forgot')">Forgot password?</button>
        </label>
        <input class="auth-input" type="password" [(ngModel)]="password"
          placeholder="••••••••" autocomplete="current-password">
      </div>
      <button class="auth-btn-primary" [class.loading]="loading" (click)="onLogin()" [disabled]="loading">
        <span *ngIf="!loading">Sign In</span>
        <span *ngIf="loading" class="auth-spinner"></span>
      </button>
    </ng-container>

    <!-- ── Sign up view ── -->
    <ng-container *ngIf="view() === 'signup'">
      <div class="auth-field">
        <label class="auth-label">Email</label>
        <input class="auth-input" type="email" [(ngModel)]="email"
          placeholder="you@example.com" autocomplete="email" autofocus>
      </div>
      <div class="auth-field">
        <label class="auth-label">Password</label>
        <input class="auth-input" type="password" [(ngModel)]="password"
          placeholder="Min. 8 characters" autocomplete="new-password">
      </div>
      <div class="auth-field">
        <label class="auth-label">Confirm Password</label>
        <input class="auth-input" type="password" [(ngModel)]="confirmPassword"
          placeholder="••••••••" autocomplete="new-password">
      </div>
      <button class="auth-btn-primary" [class.loading]="loading" (click)="onSignup()" [disabled]="loading">
        <span *ngIf="!loading">Create Account</span>
        <span *ngIf="loading" class="auth-spinner"></span>
      </button>
    </ng-container>

    <!-- ── Forgot password view ── -->
    <ng-container *ngIf="view() === 'forgot'">
      <p class="auth-forgot-title">Reset your password</p>
      <div class="auth-field">
        <label class="auth-label">Email address</label>
        <input class="auth-input" type="email" [(ngModel)]="email"
          placeholder="you@example.com" autocomplete="email" autofocus>
      </div>
      <button class="auth-btn-primary" [class.loading]="loading" (click)="onForgot()" [disabled]="loading">
        <span *ngIf="!loading">Send Reset Link</span>
        <span *ngIf="loading" class="auth-spinner"></span>
      </button>
      <p class="auth-oauth-hint">
        Signed up with Google? Use <strong>Continue with Google</strong> below instead - there's no password to reset.
      </p>
      <button class="auth-back-btn" (click)="setView('login')">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"/></svg>
        Back to sign in
      </button>
    </ng-container>

    <!-- Divider -->
    <div class="auth-divider" *ngIf="view() !== 'forgot'">
      <span>or</span>
    </div>

    <!-- Google sign in -->
    <button class="auth-btn-google" (click)="onGoogle()" [disabled]="loading" *ngIf="view() !== 'forgot'">
      <svg width="16" height="16" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
      Continue with Google
    </button>

    <!-- Footer -->
    <p class="auth-footer">
      By signing in you agree to our
      <a href="/docs/terms" target="_blank">Terms</a> and
      <a href="/docs/privacy" target="_blank">Privacy Policy</a>.
    </p>

  </div>
</div>
